// Func = limiting Scope for this file
var lastScrollTop = 0;
var documentHeight = $( window ).height();

function resizeWindow(){}

(function(){

	// Mobile Device
	if(window.innerWidth < 768){
		// Remove the "<br>" for UVP in mobile
		if($(".top-content__uvp").length > 0){
			var uvpTitle = $(".top-content__uvp .uvp_title").html();
			var uvpTitleReplaced = uvpTitle.replace(/<br>/g, "");
			$(".top-content__uvp .uvp_title").html(uvpTitleReplaced);
	
			var uvpSpan = $(".top-content__uvp .uvp_span").html();
			var uvpSpanReplaced = uvpSpan.replace(/<br>/g, "");
			$(".top-content__uvp .uvp_span").html(uvpSpanReplaced);
		}
		
		if($(".three_columns").length > 0){
			setTimeout(function(){
				$( ".three_columns .each_column" ).each(function() {
					$(this).on("click", function(e){
						console.log(this);
						if($(this).hasClass("active")){
							$(this).removeClass("active");
						}else{
							$(this).addClass("active");
						}
					});
				});
			}, 100);
		}
	}

	// Desplegable menu MOBILE
	// Open
	$(" #mobile-menu-button ").on("click", function(e){
		e.preventDefault();
		$(this).addClass('opened');
		$('.mobile-navigation').addClass('opened');
	});
	// Close
	$(" #close-menu ").on("click", function(e){
		e.preventDefault();
		$('#mobile-menu-button').removeClass('opened');
		$('.mobile-navigation').removeClass('opened');
	});

	// Set position of captions for the single quad gallery images
	setTimeout(function(){
		$( ".single_quad" ).each(function() {
			var singleDots = $(".single_quad .single_quad__images .slick-dots").width();
			var singleCaption = $(".single_quad .single_quad__images .each_image .caption");
			var rightSpace = singleDots + 70;

			singleCaption.css("right", rightSpace+'px');
		});
	}, 100);

	// Get width map icons
	/*setTimeout(function(){
		$( ".locationMod_map-pin" ).each(function() {
			var locationLabel = $(this).find('span').width();
			var locationIcon = $(this).find('.lazyload').width();
			var locationPin = $(this);
			var locationWidth = locationLabel + locationIcon;
			console.log(locationIcon +'+'+ locationLabel);

			locationPin.css("width", locationWidth+'px');
		});
	}, 1000);*/

	// Hide first option in select fields forms
	let field = $('.form-module-wrapper .form-module__field')
	if($(field).hasClass('dropdown') || $(field).hasClass('countries')){
		let option = $('.form-module-wrapper .form-module__field select option:first-child');
		option.text('Select');
	}
	
	// Add placeholder to input firms
	$( ".form-module-wrapper .form-module__field.date" ).each(function() {
		let label = $(this).find('label').text();
		$(this).find('input').attr('placeholder', 'MM//DD/YYYY');
	});
	/*$( ".form-module-wrapper .form-module__field.date" ).each(function() {
		let label = $(this).find('label').text();
		$(this).find('input').attr('placeholder', label);
	});*/

	//div effect for Btn
	setTimeout(function(){
		$('.btn, .signup-btn').filter(function(i,item){
			let lineText = $(item).text();
			$(item).html(`<span data-hover="${lineText}">${lineText}</span>`);
		});
	}, 100);
	
	
	$(document).ready(function () {

		// HOME MAP
		document.querySelectorAll('.locationMod').forEach(mod => {
			mod.querySelectorAll('[data-ref*="item"]').forEach(btn => {
				btn.addEventListener('click', () => {
					mod.querySelectorAll('[data-ref*="item"]').forEach(bt => bt.classList.remove('active') );
					mod.querySelectorAll(`[data-ref="${btn.dataset.ref}"]`).forEach(item => item.classList.add('active') );
				});
			});

			// MAP INTRO
			mod.querySelectorAll('[data-ref="item-intro"]').forEach(btn => {
				btn.addEventListener('mouseenter', () => {
					mod.querySelectorAll('[data-ref*="item"]').forEach(bt => bt.classList.remove('active') );
					mod.querySelectorAll(`[data-ref="item-intro"]`).forEach(item => item.classList.add('active') );
				});
			});
		});

		//Onload Animation Copy Set Attr
		setTimeout(function(){
			$('.animation_text').filter(function(i,item){
				let pseudoCopy = $(item).text();
				$(item).attr("title", pseudoCopy);
			});
		}, 1000);

		// RELLAX
		if ( document.querySelector('.js-rellax') ) {
			const rellax = new Rellax('.js-rellax', {
				center: true
			});
		}

		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		// Animation Scroll Down Click
		$(" #scroll-down ").on("click", function(){
			$('html,body').animate({
				scrollTop: $(".intro-content").offset().top - 10
			}, 1000);			
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	var st = window.pageYOffset || document.documentElement.scrollTop;
	
	if ($('.load_animation').length > 0) {
		$('.load_animation').each(function () {
			
			var offset = $( this ).offset();
			if(st > (Math.round( offset.top ) ) - documentHeight ){
				$(this).addClass("fade-in");
			}

		});
	}


	//if(st == )
	if(st > 0){
		// Header Class
		document.getElementById('header').classList.add('down');
		// Reserve button scroll
		document.getElementsByClassName('reserve-now')[0].classList.add('btn');

		var logoUrl = site_url + 'assets/svg/IconLogoScroll.svg';
		setTimeout(function(){
			document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl)
		}, 300);
	} else {
		// Header Class
		document.getElementById('header').classList.remove('down');
		// Reserve button scroll
		document.getElementsByClassName('reserve-now')[0].classList.remove('btn');

		var logoUrl = site_url + 'assets/svg/logo.svg';
		setTimeout(function(){
			document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl)
		}, 300);
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}